import WSClient from './WSClient';

export default WSClient;
